import { NgClass } from '@angular/common';
import { HostBinding, ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SwatchComponentDef } from '@df/catalog-ui/product/swatch/swatch.component.def';
import { DfModuleImageModule } from '@df/module-image/df-module-image.module';

/**
 * You can pass either option or value + attributeCode pair
 *
 * IMPORTANT: width is required! See below
 *
 * <swatch [option]="option" [style.width.px]="20"></swatch>
 * <swatch [value]="colorValue" attributeCode="color" [style.width.px]="20"></swatch>
 */
@Component({
    standalone: true,
    imports: [NgClass, DfModuleImageModule],
    selector: 'swatch',
    templateUrl: './swatch.html',
    styleUrl: './swatch.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SwatchComponent extends SwatchComponentDef {
    @Input()
    @HostBinding('class.disabled')
    disabled = false;

    get swatch(): string {
        if (this.option && typeof this.option !== 'string') {
            return this.option.swatch || '';
        }
        return '';
    }

    protected get altText(): string {
        if (this.option && typeof this.option !== 'string') {
            return this.option.label?.toString() || '';
        }

        return '';
    }
}
